import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { toast } from "sonner";

const CreatorOnboarding = () => {
  const navigate = useNavigate();

  const handleStartCreating = () => {
    toast("Join our community of creators!", {
      description: "Sign up to start sharing your recipes"
    });
    navigate("/login?signup=true");
  };

  return (
    <>
      <Header />
      <main className="min-h-screen py-12 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Turn Your Air Fryer Recipes Into Income
            </h1>
            <p className="text-lg text-gray-600 mb-8">
              Join the leading platform for air fryer recipe creators and monetize your culinary expertise. 
              Our platform is community-owned, with plans to distribute 5-10% ownership 
              to creators through tokens. Your contribution shapes both the platform 
              and your stake in it.
            </p>
            <div className="flex justify-center mb-12">
              <Button 
                size="lg" 
                onClick={handleStartCreating}
                className="bg-black hover:bg-black/90 text-white px-8"
              >
                Register an Account
              </Button>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="text-4xl font-bold text-primary mb-2">70%</div>
              <p className="text-gray-600">Commission on Every Sale</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="text-4xl font-bold text-primary mb-2">50K+</div>
              <p className="text-gray-600">Monthly Active Users</p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="text-4xl font-bold text-primary mb-2">$2,500+</div>
              <p className="text-gray-600">Example Creator Monthly Earnings</p>
            </div>
          </div>

          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center mb-12">Everything You Need to Succeed</h2>
            <div className="grid md:grid-cols-2 gap-8 mb-16">
              <div className="space-y-4">
                <h3 className="text-xl font-semibold">Easy Recipe Upload</h3>
                <p className="text-gray-600">Convert any recipe for air fryer use instantly with our AI technology. Upload via URL, text, or photos.</p>
              </div>
              <div className="space-y-4">
                <h3 className="text-xl font-semibold">Flexible Monetization</h3>
                <p className="text-gray-600">Set your own prices, offer subscriptions, or keep recipes free. You're in control of your income.</p>
              </div>
              <div className="space-y-4">
                <h3 className="text-xl font-semibold">Detailed Analytics</h3>
                <p className="text-gray-600">Track views, earnings, and engagement. Make data-driven decisions to grow your audience.</p>
              </div>
              <div className="space-y-4">
                <h3 className="text-xl font-semibold">Built-in Audience</h3>
                <p className="text-gray-600">Access thousands of air fryer enthusiasts actively looking for new recipes.</p>
              </div>
              <div className="space-y-4">
                <h3 className="text-xl font-semibold">Secure Payments</h3>
                <p className="text-gray-600">Automatic payment processing and instant transfers to your account every month.</p>
              </div>
              <div className="space-y-4">
                <h3 className="text-xl font-semibold">Creator Support</h3>
                <p className="text-gray-600">Dedicated support team and resources to help you create successful recipes.</p>
              </div>
            </div>
          </div>

          <div className="bg-primary/5 p-8 rounded-lg max-w-4xl mx-auto mb-16">
            <h2 className="text-2xl font-semibold mb-4 text-center">Community Ownership</h2>
            <p className="text-gray-600 text-center">
              We believe in shared success. As part of our commitment to the community, 
              we plan to airdrop 5-10% ownership tokens to our creators. Your share 
              will be based on your contributions to the platform - the more value 
              you bring, the larger your stake in our shared success.
            </p>
          </div>

          <div className="max-w-2xl mx-auto text-center space-y-8 mb-12">
            <h2 className="text-3xl font-bold">Ready to Start Your Creator Journey?</h2>
            <p className="text-lg text-gray-600">
              Join our community of successful recipe creators and start earning from your expertise
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button 
                size="lg" 
                onClick={handleStartCreating}
                className="bg-black hover:bg-black/90 text-white px-8"
              >
                Register an Account
              </Button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default CreatorOnboarding;
